module.exports = __webpack_public_path__ + "img/form-fail.631dd35.png";